module.exports = __webpack_public_path__ + "img/08.b5a09418.jpg";